export const featureFlagNames = {
  userHasAccessToEditBooking: 'customer-platform-gf-online-booking-edit',
};

export interface FeatureFlags {
  [featureFlagName: string]: boolean;
}
